/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SpaceId } from "../../commons/types/SpaceId";
import { AppId } from "../../commons/types/AppId";
export const AiGenerateSampleDataJobConfig = core.serialization.object({
    spaceId: SpaceId,
    appId: AppId,
});
